export const getSpeedTestParticipantId = state => {
  return state.RoomMetaDataReducer.roomMetaData.speedTestParticipantId;
};
export const getSpeedTestParticipantName = state => {
  return state.RoomMetaDataReducer.roomMetaData.speedTestParticipantName;
};
export const getSpeedTestDisconnectUserName = state => {
  return state.RoomMetaDataReducer.roomMetaData.speedTestDisconnectUserName;
};
export const getSpeedTestExecutedFlag = state => {
  return state.RoomMetaDataReducer.roomMetaData.speedTestExecutedFlag;
};